/**
 * Aramgah bootstrap. Registers components, wires gate -> app.
 */
import './components/gate.ts';
import './spatial/scene.ts';
import './components/tier-card.ts';
import './components/monthly-bars.ts';
import './components/category-rank.ts';
import './components/merchant-rank.ts';
import './components/impulse-spotlight.ts';
import './components/tx-feed.ts';
import './components/share-card.ts';
import './components/ppg-capture.ts';
import './components/dosha-window.ts';
import './components/chrono-prediction.ts';
import './components/bedtime-stories.ts';
import './components/voice-log.ts';
import './components/paywall.ts';
import './components/consent-modal.ts';
import './components/connect-section.ts';

import { store } from './store.ts';
import { loadSummary } from './storage.ts';
import { decryptJSON } from './crypto.ts';
import { formatHours } from './types.ts';
import type { SleepSummary } from './types.ts';
import './sync/sync-v2.ts';

async function bootstrap(): Promise<void> {
  const cached = await loadSummary();
  if (cached) {
    store.patch({ phase: 'ready', summary: cached });
    revealApp();
    refreshHero(cached);
    return;
  }

  const hashPasscode = location.hash.slice(1).trim();
  const sessionPasscode = sessionStorage.getItem('aramgah:passcode') ?? '';
  const passcode = hashPasscode || sessionPasscode;
  if (passcode) {
    try {
      const summary = await fetchAndDecrypt(passcode);
      store.patch({ phase: 'ready', summary });
      revealApp();
      refreshHero(summary);
      return;
    } catch {
      // fall through to gate
    }
  }
  store.patch({ phase: 'gate' });
  showGate();
}

async function fetchAndDecrypt(passcode: string): Promise<SleepSummary> {
  const r = await fetch('/data.encrypted.json', { cache: 'no-cache' });
  if (!r.ok) throw new Error('fetch failed');
  const body = await r.json() as { ciphertext: string };
  return decryptJSON<SleepSummary>(passcode, body.ciphertext);
}

function showGate(): void {
  const gate = document.querySelector('aramgah-gate');
  const app = document.getElementById('app');
  if (gate) gate.removeAttribute('hidden');
  if (app) app.hidden = true;
}

function revealApp(): void {
  const gate = document.querySelector('aramgah-gate');
  const app = document.getElementById('app');
  if (gate) gate.setAttribute('hidden', '');
  if (app) app.hidden = false;
}

function refreshHero(s: SleepSummary): void {
  const total = document.getElementById('total');
  const sub = document.getElementById('hero-sub');
  if (total) total.textContent = formatHours(s.avg_hours);
  if (sub) sub.textContent = `${s.total_nights_logged} nights logged · last ${s.window_days} days`;
}

store.subscribe((s) => {
  if (s.phase === 'ready' && s.summary) {
    revealApp();
    refreshHero(s.summary);
  }
});

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => { /* ignore */ });
  });
}

bootstrap();
import { mountAmbient as mountEmpireSelf } from './agent/hook.ts';
queueMicrotask(() => mountEmpireSelf());
